import tableTransactions from "./tableTransactions"
export default tableTransactions;
